export default __webpack_public_path__ + "aeb6f3af96637c3361698f81f5c8454a.svg";